import { render, staticRenderFns } from "./SitePage.vue?vue&type=template&id=3dda2de6&scoped=true"
import script from "./SitePage.vue?vue&type=script&lang=js"
export * from "./SitePage.vue?vue&type=script&lang=js"
import style0 from "./SitePage.vue?vue&type=style&index=0&id=3dda2de6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dda2de6",
  null
  
)

export default component.exports